export enum Color {
  Grey = '#828282',
  Primary = '#FFBB00',
  Green = '#11FF00',
  Red = '#FF0000',
}
